class SearchBox {
  constructor(formWrapper) {
    // Store references to form and various elements inside it
    this.formWrapper = formWrapper;
    this.searchGroup = formWrapper.querySelectorAll(".search-service");
    this.dropDown = formWrapper.querySelector("#ca_dropdown");
    this.searchBox = formWrapper.querySelector("#provider-name");
    this.hService = formWrapper.querySelector("#hiddenServices");
    this.provInput = formWrapper.querySelector("#provider-name");
    this.locField = formWrapper.querySelector("#zipcode-loc");
    this.radius = formWrapper.querySelector("#radius-search");
    this.servResults = formWrapper.querySelector("#ca-service-results");
    this.searchResults = formWrapper.querySelector("#ca-search-results");
    this.searchForm = formWrapper.querySelector("#searchForm");
    this.latField = formWrapper.querySelector("#lat");
    this.lngField = formWrapper.querySelector("#lng");
    this.cityField = formWrapper.querySelector("#city");
    this.stateField = formWrapper.querySelector("#state");
    this.zipField = formWrapper.querySelector("#zip");

    // Initialize internal state variables
    this.isSpinnerVisible = false;
    this.typingTimer;
    this.visible = false;
    this.zip = 10;
    this.autocompleteInitialized = false;
    this.validLocationSelected = false; // Track if user selected a valid location

    console.log("search box constructor");

    // Bind event listeners and initialize features
    this.bindEvents();
    this.initAutocomplete();
    this.checkStorage();
  }

  bindEvents() {
    // When radius changes, store the new value in `this.zip`
    this.radius.addEventListener("change", e => {
      this.zip = e.target.value;
    });

    // Show or hide the dropdown when the searchBox is clicked
    this.searchBox.addEventListener("click", el => {
      if (this.visible) {
        this.hide();
        console.log("hide this ");
      } else {
        this.show();
        console.log("show this 2");
      }
    });

    // If the location field loses focus and no valid location was selected, reset it
    this.locField.addEventListener("blur", () => {
      if (!this.validLocationSelected) {
        this.locField.value = "";
        this.locField.setAttribute("placeholder", "Select City or Zip Code");
        this.locField.classList.add("invalid-location");
      }
    });

    // Handle form submission
    this.searchForm.addEventListener("submit", e => {
      e.preventDefault();
      this.handleSubmit();
    });

    // Hide dropdown and remove styling when user starts typing in the searchBox
    this.searchBox.addEventListener("keyup", el => {
      this.hide();
      this.provInput.classList.remove("font-bold");
    });

    // Add click events to each search-service element (service category)
    this.searchGroup.forEach(e => {
      e.addEventListener("click", el => {
        this.handleSearchGroupClick(e);
      });
    });

    // Select all text in location field on focus if it has a value
    this.locField.addEventListener("focus", () => {
      if (this.locField.value) {
        this.locField.select();
      }
    });
  }

  checkStorage() {
    // Check local storage for previously stored location data and pre-populate fields
    if (localStorage.getItem("ca_search_lat")) {
      let storLat = localStorage.getItem("ca_search_lat");
      let storLng = localStorage.getItem("ca_search_lng");
      let storSt = localStorage.getItem("ca_search_state");
      let storCty = localStorage.getItem("ca_search_city");
      let storZip = localStorage.getItem("ca_search_zip");
      this.latField.setAttribute("value", storLat ? storLat : "");
      this.lngField.setAttribute("value", storLng ? storLng : "");
      this.cityField.setAttribute("value", storCty ? storCty : "");
      this.stateField.setAttribute("value", storSt ? storSt : "");
      this.zipField.setAttribute("value", storZip ? storZip : "");
      this.locField.setAttribute("value", `${storCty ? storCty + "," : ""} ${storSt ? storSt : ""} ${storZip ? storZip : ""}`);
      this.locField.setAttribute("placeholder", `${storCty ? storCty + "," : ""}, ${storSt ? storSt : ""} ${storZip ? storZip : ""}`);
    }
  }

  initAutocomplete() {
    // Initialize Google Maps Places Autocomplete for the location field
    const center = { lat: 50.064192, lng: -130.605469 };
    const defaultBounds = {
      north: center.lat + 0.1,
      south: center.lat - 0.1,
      east: center.lng + 0.1,
      west: center.lng - 0.1
    };

    const options = {
      bounds: defaultBounds,
      componentRestrictions: { country: "us" },
      fields: ["name", "geometry.location", "formatted_address", "address_components"],
      strictBounds: false
    };

    try {
      const autocomplete = new google.maps.places.Autocomplete(this.locField, options);
      autocomplete.addListener("place_changed", () => {
        this.validLocationSelected = false;
        const place = autocomplete.getPlace();

        if (!place.geometry) {
          console.error("No geometry data found for the place.");
          this.locField.placeholder = "Enter a place";
          return;
        }

        // Clear previous stored location data
        this.clearLocationData();

        // Extract city, state, and zip from the address components
        const addressComponents = place.address_components;
        let city = "";
        let zip = "";
        let state = "";

        addressComponents.forEach(component => {
          if (component.types.includes("postal_code")) {
            zip = component.short_name;
          }
          if (component.types.includes("locality")) {
            city = component.short_name;
          }
          if (component.types.includes("administrative_area_level_1")) {
            state = component.short_name;
          }
        });

        // Validate that we have at least city or zip
        if (city || zip) {
          this.validLocationSelected = true;
          this.locField.classList.remove("invalid-location");
          this.storeLocationData(place.geometry.location.lat(), place.geometry.location.lng(), city, zip, state);
        } else {
          this.locField.value = "";
          this.locField.placeholder = "You Must Select a City or Zip Code";
          this.locField.classList.add("invalid-location");
        }
      });
      this.autocompleteInitialized = true;
    } catch (error) {
      console.error("Error initializing autocomplete:", error);
    }
  }

  clearLocationData() {
    // Remove any previously stored location data to start fresh
    localStorage.removeItem("ca_search_lat");
    localStorage.removeItem("ca_search_lng");
    localStorage.removeItem("ca_search_zip");
    localStorage.removeItem("ca_search_city");
    localStorage.removeItem("ca_search_state");

    this.latField.value = "";
    this.lngField.value = "";
    this.cityField.value = "";
    this.stateField.value = "";
    this.zipField.value = "";
  }

  storeLocationData(lat, lng, city, zip, state) {
    // Store the new location data both in fields and localStorage for future use
    this.latField.value = lat;
    localStorage.setItem("ca_search_lat", lat);

    this.lngField.value = lng;
    localStorage.setItem("ca_search_lng", lng);

    if (zip) {
      this.zipField.value = zip;
      localStorage.setItem("ca_search_zip", zip);
    }

    if (city) {
      this.cityField.value = city;
      localStorage.setItem("ca_search_city", city);
    }

    if (state) {
      this.stateField.value = state;
      localStorage.setItem("ca_search_state", state);
    }
  }

  handleSubmit() {
    // Handle form submission:
    // 1. Check if a valid location is selected.
    // 2. Ensure a service is selected or provider name is sufficiently long.
    // 3. Submit form if conditions are met, otherwise show appropriate errors.
    if (this.validLocationSelected) {
      // If location is valid, proceed
    } else {
      // If not valid, show an error or reset field
    }

    if (this.hService.value.length || this.searchBox.value.length > 3) {
      if (this.latField.value > 1 || this.lngField.value > 1) {
        this.searchForm.submit();
      } else {
        this.locField.value = "";
        this.locField.setAttribute("placeholder", "Invalid Location");
        this.locField.classList.add("placeholder-red-500");
      }
    } else {
      // If no service or name is provided or too short, show errors
      if (!this.hService.value.length) {
        this.provInput.classList.remove("border-primaryBlue");
        this.provInput.classList.add("border-red-500");
        this.provInput.setAttribute("placeholder", "Please enter a service or provider name");
      }
      if (this.searchBox.value.length > 0 && this.searchBox.value.length < 4) {
        this.provInput.value = "";
        this.provInput.setAttribute("placeholder", "Please enter more than 3 digits");
      }
      this.provInput.classList.add("font-bold");
      this.provInput.classList.add("placeholder-red-500");
    }
  }

  handleSearchGroupClick(e) {
    var data = JSON.stringify({
      id: parseInt(e.dataset.id),
      name: e.dataset.name,
      slug: e.dataset.slug
    });

    console.log(e.dataset.slug);

    if (this.visible) {
      // Check if Support & Referrals is chosen
      if (e.dataset.slug === "support-referrals") {
        this.searchForm.setAttribute("action", "/ca-search");
        document.getElementById("support-search").value = "1";

        // Change the hidden service field to not pass standard service array
        this.hService.setAttribute("name", "service");
        this.hService.setAttribute("value", "");

        this.changeZip("support");
      } else {
        // If another service is chosen, reset support referrals field
        document.getElementById("support-search").value = "";

        // Ensure hidden input is set up for standard services
        this.hService.setAttribute("name", "services[]");
        this.hService.setAttribute("value", e.dataset.id || "");

        this.changeZip(e.dataset.id);
      }

      this.hService.setAttribute("value", e.dataset.id);
      this.provInput.classList.add("font-bold");
      this.provInput.classList.remove("placeholder-red-500");
      this.provInput.classList.add("border-primaryBlue");
      this.provInput.classList.remove("border-red-500");
      this.provInput.classList.add("placeholder-primaryBlue");
      this.provInput.setAttribute("placeholder", e.dataset.name);

      this.hide(); // Hide the dropdown after selecting a service
    }
  }

  show() {
    // Display the dropdown and set it as visible
    this.dropDown.classList.remove("hidden");
    this.dropDown.classList.add("block");
    this.dropDown.style.transform = "translate3d(0px, 46.4px, 0px)";
    this.visible = true;

    // Add a clickOutside listener to hide dropdown if user clicks elsewhere
    document.body.addEventListener(
      "click",
      ev => {
        this.clickOutside(ev, this.dropDown);
      },
      true
    );

    // Delay adding event listener to avoid immediate conflict with the current click event
    setTimeout(() => {
      document.body.addEventListener("click", (this.boundClickOutside = this.clickOutside.bind(this)), true);
    }, 0);
  }

  hide() {
    // Hide the dropdown and remove the outside click listener
    this.dropDown.classList.remove("block");
    this.dropDown.classList.add("hidden");
    this.dropDown.style.transform = "translate3d(755.2px, 204.8px, 0px)";
    this.visible = false;
    document.body.removeEventListener("click", this.boundClickOutside, true);
  }

  clickOutside(ev, targetEl) {
    // If user clicks outside of the dropdown and searchBox, hide the dropdown
    const clickedEl = ev.target;
    if (!this.searchBox.contains(ev.target) && !this.dropDown.contains(ev.target)) {
      this.hide();
    }
  }

  changeZip(service) {
    // Adjust the radius input and visibility based on the selected service

    if (service === "support") {
      // For 'Support & Referrals', fixed radius of 25
      this.radius.value = "25";
      this.radius.classList.add("block");
      this.radius.classList.remove("hidden");
      return; // Important: return here to avoid running the other conditions
    }

    // For services with IDs 10, 11, 12, set radius to 70 and hide the radius input
    if (service == 10 || service == 11 || service == 12) {
      this.radius.value = "70";
      this.radius.classList.add("hidden");
      this.radius.classList.remove("block");
    } else {
      // For all other services, revert to stored zip radius and show radius input
      this.radius.value = this.zip;
      this.radius.classList.add("block");
      this.radius.classList.remove("hidden");
    }
  }
}

// Export a function to initialize SearchBox for all form wrappers on the page
export function searchBox() {
  const formWrappers = document.querySelectorAll(".form-wrapper");
  formWrappers.forEach(formWrapper => {
    new SearchBox(formWrapper);
  });
}
